import { GET_EMPLOYER_CONTRACT_LIST_SUCCESS } from '../../constants/employer'

const initialState = {
  contractRows: []
}

const contractsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_EMPLOYER_CONTRACT_LIST_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          contractRows: action.data
        }
      )
    default:
      return state
  }
}

export default contractsReducer
